module.exports = __webpack_public_path__ + "static/media/3K86RRajPEM.82a71b36.jpg";